import { Pipe, PipeTransform } from '@angular/core';
import { Application } from './../../../enums/application.enums';

@Pipe({
  name: 'priceDiscount',
  standalone: true
})
export class PriceDiscountPipe implements PipeTransform {
  transform(price: any, discount): any {
    return (
      (Number(price) * (Application.ONE_HUNDRED - Number(discount))) /
      Application.ONE_HUNDRED
    ).toFixed(Application.TWO);
  }
}
